import { MouseEvent, useRef, useState, useCallback } from 'react';

type UseClickOrDragOptions = {
  threshold?: number;
};

type UseClickOrDragReturn = {
  onMouseDown: (e: MouseEvent) => void;
  onMouseMove: (e: MouseEvent) => void;
  onMouseUp: (
    e: MouseEvent,
    onClick?: (e: MouseEvent) => void,
    onDrag?: (e: MouseEvent) => void
  ) => void;
};

export function useClickOrDrag({
  threshold = 5,
}: UseClickOrDragOptions = {}): UseClickOrDragReturn {
  const [isDragging, setIsDragging] = useState(false);
  const startPos = useRef<{ x: number; y: number }>({ x: 0, y: 0 });

  const onMouseDown = useCallback((e: MouseEvent) => {
    setIsDragging(false);
    startPos.current = { x: e.clientX, y: e.clientY };
  }, []);

  const onMouseMove = useCallback(
    (e: MouseEvent) => {
      const dx = Math.abs(e.clientX - startPos.current.x);
      const dy = Math.abs(e.clientY - startPos.current.y);
      if (dx > threshold || dy > threshold) {
        setIsDragging(true);
      }
    },
    [threshold]
  );

  const onMouseUp = useCallback(
    (
      e: MouseEvent,
      onClick?: (e: MouseEvent) => void,
      onDrag?: (e: MouseEvent) => void
    ) => {
      if (isDragging) {
        onDrag?.(e);
      } else {
        onClick?.(e);
      }
    },
    [isDragging]
  );

  return {
    onMouseDown,
    onMouseMove,
    onMouseUp,
  };
}
